import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Layout, Col, Row, Form, Input, Button } from "antd";
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useForm } from "antd/es/form/Form";
import {
    app, getAuth, getUser, setSessionID, signInWithEmailAndPassword
} from "../context/firebaseConfig";
import { getPrj } from "../constants/methods";

import '../assets/css/login.css'


const Login = (props) => {
    const nav = useNavigate();
    const { t } = useTranslation();
    const { Footer } = Layout;
    const [form] = useForm();
    const [error, seterror] = useState('')
    const [auth, setAuth] = useState();


    useEffect(()=> {
        // window.localStorage.clear(); 
        localStorage.removeItem('sessionID'); 
        localStorage.removeItem('viewedAlerts');
        setAuth(getAuth(app));
    }, []);


    const FIRST_PAGE = '/pittpanel'; // '/dashboard';
    const withEmail = async e => {
        const { user, password } = e;
        // 1. Limpieza preventiva antes de intentar login
        sessionStorage.clear();
        localStorage.removeItem('sessionID');

        await signInWithEmailAndPassword(auth, user, password)
            .then(async result => {
                // Generar el ID antes de nada
                const newSessionID = +new Date();
                // Guardar localmente y actualizar la base de datos 
                sessionStorage.setItem('sessionID', newSessionID);
                // Esto disparará los watchers, pero AuthContext ahora sabrá ignorarlo
                await setSessionID({user: result.user.email, sessionID: newSessionID});

                // 2. OBTENEMOS el rol directamente de la base de datos aquí mismo
                // para no depender de lo que el AuthContext tarde en procesar
                const dbUser = await getUser(result.user.email);
                const roles = dbUser?.rol || [];

                let to = FIRST_PAGE; // Default /pittpanel

                if (roles.includes('OPERATOR')) {
                    to = '/mapped';
                } else if (roles.includes('MANAGEMENT')) {
                    to = '/dashboard';
                }

                // 3. Pequeño retardo de seguridad (100ms) para que Firebase Auth centralice el token
                setTimeout(() => {
                    nav(to, { replace: true });
                }, 100);
                
            })
            .catch(error => {
                console.log(error);                
                // seterror(t(error.code));
                if((error.code).includes("auth/invalid-login-credentials")){ 
                    seterror(t('ERRMSG_INVALID_CREDENTIALS')); // Credenciales no válidas
                } else if((error.code).includes("auth/invalid-email")){
                    seterror(t('ERRMSG_INVALID_EMAIL')); // Email no válido
                } else{
                    seterror(t(error.code));
                };
            });
    };


    return (
        <Layout style={{ height: "90vh" }}>
            <Row justify='center' align='middle' style={{ height: "80vh" }}>
                <Col span={8} style={{ "textAlign": "center"}}>
                    <img src={`/assets/img/${getPrj()}/logo.png`} alt="" />
                </Col>
                <Col span={8} style={{ 
                    display: "flex", 
                    "justifyContent": "center"
                    }}>
                    <div className='d-flex bg-light align-items-center text-center login-container'
                        style={{
                            padding: 24,
                            width: 400
                        }}
                    >
                        {(
                            <Form className="login-form" onFinish={withEmail} form={form}>
                                <Form.Item>
                                    <h1 className='text-primary'>{t('LOGIN')}</h1>
                                </Form.Item>
                                { error ? 
                                    <Form.Item style={{ color: "rgba(240,0,0,1)" }}> {error} </Form.Item> 
                                    : 
                                    null
                                }
                                <Form.Item
                                    name="user"
                                    rules={[{ required: true, message: t('ERRMSG_FIELD_REQUIRED') }]}
                                >
                                    <Input 
                                        prefix={<UserOutlined  style={{ color: "rgba(0,0,0,.25)" }} /> } 
                                        placeholder={t('USERNAME')} 
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    rules={[{ required: true, message: t('ERRMSG_FIELD_REQUIRED') }]}
                                >
                                    <Input.Password
                                        prefix={
                                            <LockOutlined style={{color: "rgba(0,0,0,.25)"}}
                                            />
                                        }
                                        type="password"
                                        placeholder={t('PASSWORD')}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="login-form-button"
                                        style={{ marginRight: 10 }}
                                    >
                                        {t('BUTTON_LOGIN')}
                                    </Button>
                                </Form.Item>
                            </Form>
                        )}
                    </div>
                </Col>
            </Row>
            <Footer className="fixed-bottom d-none d-sm-block" style={{ textAlign: "center" }}>
                <span>version: 2.1.2 </span> Powered by <a href='https://kaps.es'> Kaps Management Group</a>
                {/* ESTA VERSION HAY QUE ACTUALIZARLA TAMBIEN EN AuthContext.js, para avisar al usuario que actualice 
                ESTA VERSION HABRA QUE ACTUALIZARLA EN TODOS LOS PROYECTOS DE FIREBASE config>console_version: 
                En todos los proyectos que usen este panel (ahp, rep, drz, bai, tgd, caj, casercc y remotoold*/}
            </Footer>
        </Layout>
    );
};
export default Login;